import { AxiosResponse } from 'axios';
import { createOrder, loadOrder, updateOrder } from '@/api/order';
import { baseListService } from '@/services/baseService';
import { IApiModifyResponse, IOrderApiListResponse, IOrderFilters } from '@/types';
import { IListParams } from '@/types/service';
import { AppError } from '@/errors/appError';
import { OrderFactory } from '@/models/orderFactory';
import { useOrderStore } from '@/stores/order';
import { useAppStore } from '@/stores/app';

export const orderService = {
    async load(params: IListParams<IOrderFilters>): Promise<AxiosResponse<IOrderApiListResponse>> {
        const orderStore = useOrderStore();
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            const response = await baseListService<IOrderApiListResponse>(loadOrder, params);
            orderStore.items = response.data.rows.map((item) => OrderFactory.createFromPageApi(item));
            orderStore.total = response.data.total;

            return response;
        } catch (e) {
            throw new AppError(`Unable load order list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },

    async create(item: Record<string, any>): Promise<AxiosResponse<IApiModifyResponse>> {
        try {
            const data = { rows: [item] };
            return await createOrder(data);
        } catch (e) {
            throw new AppError(`Unable to create order, request error`, { cause: e });
        } finally {
        }
    },

    async updateStatus(id: number, statusId: number): Promise<AxiosResponse<IApiModifyResponse>> {
        try {
            return await updateOrder(id, statusId);
        } catch (e) {
            throw new AppError(`Unable to update order #${id} with status '${statusId}', request error`, { cause: e });
        } finally {
        }
    },
};
